var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionsUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.831 4.78386L2.1428 5.47206C1.47531 6.14207 1.10052 7.0493 1.10052 7.99506C1.10052 8.94082 1.47531 9.84805 2.1428 10.5181C3.5282 11.9041 5.7992 11.9089 7.1888 10.5181L7.8776 9.83046M10.169 7.53966L10.8572 6.85146C11.5247 6.18145 11.8995 5.27422 11.8995 4.32846C11.8995 3.3827 11.5247 2.47547 10.8572 1.80546C9.4718 0.419461 7.2008 0.414661 5.8112 1.80546L5.1224 2.49306M8.0822 4.63386L4.9424 7.77306",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsUrl);
export default __webpack_public_path__ + "static/media/actions-url.5d75f1d69a4a2ecba3427fd193db0507.svg";
export { ForwardRef as ReactComponent };